import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { activityDate2Human, activityTime2Human } from '../../utils/dateTime';
import './ExhibitorActivities.css';

const ExhibitorActivities = ({ title, exhibitor }) => {
	const { t, i18n } = useTranslation();
    const navigate = useNavigate();
	const lang = i18n.language;
    const [ dates, setDates ] = useState([]);
    const [ activities, setActivities ] = useState([]);

    useEffect(() => {
        if(!Array.isArray(exhibitor.activities) || !exhibitor.activities.length) {
            setActivities([]);
            return;
        }

        let activities = [...exhibitor.activities];
        activities.sort((a, b) => a.date.localeCompare(b.date));

        let date = '';
        let dates = [];
        activities.forEach(a => {
            let d = a.date.split(' ')[0];
            if(date !== d) {
                date = d;
                dates.push(d);
            }
        });

        setActivities(activities);
        setDates(dates);
    }, [ exhibitor ]);


    if(!activities.length) return null;

	return (
    <div>
        <h2>{t(title)}</h2>

        {dates.map(date => (
        <div key={date}>
            <h3>{activityDate2Human(date, lang, false)}</h3> 
            {activities.filter(a => a.date.startsWith(date)).map(item => (
            <div key={item._id} className='ExhibitorActivity'>
                <span>{activityTime2Human(item.date)}</span>
                <span
                    onClick={() => navigate(`../activity/${item._id}`)}
                >
                    {item.name[lang]}
                </span>
            </div>))}
        </div>))}        
    </div>
	);
};

ExhibitorActivities.propTypes = {
    title: PropTypes.string.isRequired,
    exhibitor: PropTypes.object.isRequired,
};

export default ExhibitorActivities;
